module.exports = __webpack_public_path__ + "img/1716362682875-WhatsApp Image 2024-05-22 at 14.19.00.jpeg.16bbeec0.webp";